module.exports = __webpack_public_path__ + "media/images/generic-team-member-8305895f57c1aba20cbc716e16d0e803.png";